import { TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';
import { PricingIssueVm } from '@/features/public/booking/util/pricingIssues.ts';

interface PricingIssuesNoticeProps
  extends React.HTMLAttributes<HTMLDivElement> {
  issues: PricingIssueVm[];
  /** Zdanie zamykające — na liście uczestników inne niż w podsumowaniu. */
  hint: string;
}

/**
 * Co blokuje rezerwację i u kogo.
 *
 * Ten sam blok stoi na obu krokach formularza: na liście uczestników mówi, co
 * poprawić, a w podsumowaniu tłumaczy, czemu nie ma harmonogramu rat. Bez tego
 * pierwszego klient dowiadywał się o problemie dopiero po przejściu dalej.
 */
const PricingIssuesNotice = ({
  issues,
  hint,
  className,
  ...props
}: PricingIssuesNoticeProps) => {
  if (issues.length === 0) {
    return null;
  }

  return (
    <div
      role="alert"
      className={cn(
        'rounded-lg border border-error-100 bg-error-100/40 px-4 py-3 text-sm text-error-300',
        className,
      )}
      {...props}
    >
      <p className="flex items-center gap-2 font-semibold">
        <TriangleAlert aria-hidden className="size-4 shrink-0" />
        Rezerwacja jest w tej chwili niemożliwa
      </p>
      <ul className="mt-1.5 list-inside list-disc">
        {issues.map((issue, index) => (
          <li key={`${index}-${issue.errorLabel}`}>
            {issue.participantLabel} — {issue.errorLabel}
          </li>
        ))}
      </ul>
      <p className="mt-2">{hint}</p>
    </div>
  );
};

export default PricingIssuesNotice;
